import classes from "../../../../../../components/Popover/popover.module.scss";
import classesProject from "Dashboard/scenes/Projects/styles/popover.module.scss";
import { useState, useCallback } from "react";
import { useAppDispatch } from "hooks/hooks";
import { debounce } from "lodash";
import { IMaskInput } from "react-imask";
import { selectState, updateBuildingWithSalesUnits } from "../../Main/main.slice";
import { useSelector } from "react-redux";
import { IBuildingUpdate } from "Dashboard/scenes/HighRiseSales/domain/IBuildingUpdate";
import { hrsService } from "Dashboard/scenes/HighRiseSales/services/hrs.services";
import { IBuildingWithSalesUnits } from "Dashboard/scenes/HighRiseSales/domain/IBuildingWithSalesUnits";

const MealPriceSettingsPopover = () => {

  const dispatch = useAppDispatch();
  const { selectedBuilding, buildings } = useSelector(selectState);
  const selectedBuildingProj = buildings[selectedBuilding];

  const [building, setBuilding] = useState<IBuildingUpdate>({
    buildingId: selectedBuildingProj.building.buildingId,
    breakfastCost: selectedBuildingProj.building.breakfastCost,
    lunchCost: selectedBuildingProj.building.lunchCost,
    dinnerCost: selectedBuildingProj.building.dinnerCost,
    cashBreakfastRate: selectedBuildingProj.building.cashBreakfastRate,
    cashLunchRate: selectedBuildingProj.building.cashLunchRate,
    cashDinnerRate: selectedBuildingProj.building.cashDinnerRate,
    // forcedField: "meal",
  });

  const delayedUpdateBuilding = useCallback(
    debounce(async (data: IBuildingUpdate, originalBuildingData: IBuildingWithSalesUnits) => {
      try {
        const response = await hrsService.updateBuilding(data);
        dispatch(updateBuildingWithSalesUnits(response));
      } catch (err) {
        console.error("Ažuriranje zgrade neuspešno, vraćam stare promene.", err);
        const revertData: IBuildingUpdate = { ...originalBuildingData.building };
        setBuilding(revertData);
        dispatch(updateBuildingWithSalesUnits(originalBuildingData));
      }
    }, 1000), [dispatch]
  );

  const updateFieldChanged = (name: string, value: string) => {
    const originalBuildingData = selectedBuildingProj;
    if (!originalBuildingData) {
      console.error("Zgrada za ažuriranje nije pronađena.");
      return;
    }

    let newValue: number | null;

    if (value !== "") {
      newValue = parseInt(value);
    } else {
      newValue = null;
    }

    let newBuilding = { ...building, [name]: newValue };
    setBuilding(newBuilding);
    delayedUpdateBuilding(newBuilding, originalBuildingData);
  };

  return (
    <>
      {building && (
        <div className={`${classesProject.mealPriceSettingsPopover} ${classes.basicPopover}`}>
          <div className={classes.row}>
            <div className={`${classes.col} ${classes.rowDir}`}>
              <label className={classes.mr5}>doručak</label>
              <IMaskInput
                className={classes.itemBorder}
                value={building.breakfastCost !== null ? `${building.breakfastCost} rsd` : ""}
                onAccept={(value, mask) => updateFieldChanged("breakfastCost", mask.unmaskedValue)}
                mask={[
                  { mask: '' },
                  {
                    mask: 'num rsd',
                    lazy: false,
                    blocks: {
                      num: {
                        mask: Number,
                        scale: 0,
                        thousandsSeparator: '.',
                      }
                    }
                  }
                ]} />
            </div>
          </div>
          <div className={classes.row}>
            <div className={`${classes.col} ${classes.rowDir}`}>
              <label className={classes.mr5}>ručak</label>
              <IMaskInput
                className={classes.itemBorder}
                value={building.lunchCost !== null ? `${building.lunchCost} rsd` : ""}
                onAccept={(value, mask) => updateFieldChanged("lunchCost", mask.unmaskedValue)}
                mask={[
                  { mask: '' },
                  {
                    mask: 'num rsd',
                    lazy: false,
                    blocks: {
                      num: {
                        mask: Number,
                        scale: 0,
                        thousandsSeparator: '.',
                      }
                    }
                  }
                ]} />
            </div>
          </div>
          <div className={classes.row}>
            <div className={`${classes.col} ${classes.rowDir}`}>
              <label className={classes.mr5}>večera</label>
              <IMaskInput
                className={classes.itemBorder}
                value={building.dinnerCost !== null ? `${building.dinnerCost} rsd` : ""}
                onAccept={(value, mask) => updateFieldChanged("dinnerCost", mask.unmaskedValue)}
                mask={[
                  { mask: '' },
                  {
                    mask: 'num rsd',
                    lazy: false,
                    blocks: {
                      num: {
                        mask: Number,
                        scale: 0,
                        thousandsSeparator: '.',
                      }
                    }
                  }
                ]} />
            </div>
          </div>

          <div className={classes.row}>
            <div className={`${classes.col} ${classes.rowDir}`}>
              <label className={classes.mr5}>keš doručak</label>
              <IMaskInput
                className={classes.itemBorder}
                value={building.cashBreakfastRate !== null ? `${building.cashBreakfastRate} rsd` : ""}
                onAccept={(value, mask) => updateFieldChanged("cashBreakfastRate", mask.unmaskedValue)}
                mask={[
                  { mask: '' },
                  {
                    mask: 'num rsd',
                    lazy: false,
                    blocks: {
                      num: {
                        mask: Number,
                        scale: 0,
                        thousandsSeparator: '.',
                      }
                    }
                  }
                ]} />
            </div>
          </div>

          <div className={classes.row}>
            <div className={`${classes.col} ${classes.rowDir}`}>
              <label className={classes.mr5}>keš ručak</label>
              <IMaskInput
                className={classes.itemBorder}
                value={building.cashLunchRate !== null ? `${building.cashLunchRate} rsd` : ""}
                onAccept={(value, mask) => updateFieldChanged("cashLunchRate", mask.unmaskedValue)}
                mask={[
                  { mask: '' },
                  {
                    mask: 'num rsd',
                    lazy: false,
                    blocks: {
                      num: {
                        mask: Number,
                        scale: 0,
                        thousandsSeparator: '.',
                      }
                    }
                  }
                ]} />
            </div>
          </div>


          <div className={classes.row}>
            <div className={`${classes.col} ${classes.rowDir}`}>
              <label className={classes.mr5}>keš večera</label>
              <IMaskInput
                className={classes.itemBorder}
                value={building.cashDinnerRate !== null ? `${building.cashDinnerRate} rsd` : ""}
                onAccept={(value, mask) => updateFieldChanged("cashDinnerRate", mask.unmaskedValue)}
                mask={[
                  { mask: '' },
                  {
                    mask: 'num rsd',
                    lazy: false,
                    blocks: {
                      num: {
                        mask: Number,
                        scale: 0,
                        thousandsSeparator: '.',
                      }
                    }
                  }
                ]} />
            </div>
          </div>

        </div>
      )}
    </>
  );
};

export default MealPriceSettingsPopover;
